// API configuration
export const apiConfig = {
  baseUrl: import.meta.env.VITE_API_BASE_URL || '/api',
  endpoints: {
    // Applications
    applications: '/applications',
    applicationById: (id: number) => `/applications/${id}`,
    applicationCredentials: (id: number) => `/applications/${id}/credentials`,
    applicationOwners: (id: number) => `/applications/${id}/owners`,
    applicationOwnerById: (appId: number, ownerId: number) => `/applications/${appId}/owners/${ownerId}`,
    applicationPermissions: (id: number) => `/applications/${id}/permissions`,
    applicationHistory: (id: number) => `/applications/${id}/history`,

    // Credentials
    credentials: '/credentials',
    credentialById: (id: number) => `/credentials/${id}`,
    expiringCredentials: '/credentials/expiring',
    credentialSummary: '/credentials/summary',

    // Owners
    owners: '/owners',
    ownerById: (id: number) => `/owners/${id}`,

    // Business Units
    businessUnits: '/business-units',
    businessUnitById: (id: number) => `/business-units/${id}`,

    // Risk Levels
    riskLevels: '/lookup/risk-levels',

    // SSO Modes
    ssoModes: '/lookup/sso-modes',

    // Audit
    auditLog: '/audit',

    // Sync
    syncApplications: '/sync/applications',
    syncStatus: '/sync/status',
  },
}
